module.exports = __webpack_public_path__ + "static/media/maveett-logo.2a3d1c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maveett-logo.png
// module id = 421
// module chunks = 0